<template>
  <div class="common">
    <search-form
    :noAdvance="true"
    :formConfig="formConfig"
    :source="searchData"
    @handleSearchSff="handleSearchSff"
    @search="search"
    >
        <template slot="btns" v-if="tabType=='review'">
            <a-button @click="showModal(1)" :loading="checkLoad" class="search-btn-item" type="primary" :disabled="!selectedRowKeys.length">同意</a-button>
            <a-button @click="showModal(2)" :loading="checkLoadCancel" class="search-btn-item btn-blue-line" :disabled="!selectedRowKeys.length">拒绝</a-button>
        </template>
        <template slot="btns" v-if="tabType=='records'">
            <a-button :loading="checkLoad" class="search-btn-item btn-blue-line" type="primary" :disabled="true">导出</a-button>
        </template>
    </search-form>

    <div class="table-common">
      <a-table
        size="middle"
        :columns="columns"
        :data-source="tableData"
        :pagination="pagination"
        :loading="loading"
        :row-key="(record,index) => record.id+'_'+record.createTime"
        @change="handleTableChange"
        bordered
        :locale="{emptyText: '暂无数据'}"
        :row-selection="tableSelect"
      >
        <template slot="costTpCd" slot-scope="text"><div style="word-break: break-all;">{{text | epsCollTpCdTrans}}</div></template>
        <template slot="feeAcrdToAmt" slot-scope="text">{{text | splitK}}</template>
        <template slot="epsPct" slot-scope="text">{{text?(text+"%"):""}}</template>
        <template slot="agrmPyFeePct" slot-scope="text">{{text === undefined ?'-':'%'}}</template>
        <template slot="pyFeeAmt" slot-scope="text">{{text | splitK}}</template>
        <template slot="feeDt" slot-scope="text">{{text | dateFormat("YYYY-mm-dd")}}</template>
        <template slot="createTime" slot-scope="text">{{text | dateFormat("YYYY-mm-dd")}}</template>
        <template slot="docId" slot-scope="text,record">{{ (record.costTpCd === '2')? record.docId : record.epsObjId }}</template>
        <template slot="operation" slot-scope="text, record">
          <a @click="toPageDetail(record)">详情</a>
        </template>
      </a-table>
      <div :class="{'table-total':pagination.total>0,'table-total-none':pagination.total==0}">
        共有记录：
        <span class="text-color-blue">{{pagination.total}} 条</span>
        <span v-if="tabType=='payfeeNo'">应付总额：
            <span class="text-color-orange">{{totalPayable(selectedRows) | splitK}} 元</span>

        </span>
        <a-button v-if="tabType=='payfeeNo'" :disabled="selectedRows.length==0" type="primary">付费</a-button>
      </div>
    </div>
    <a-modal
    width="400px"
    :title="modalTitle"
    :visible="modalShow"
    :maskClosable="false"
    :footer="null"
    @cancel="modalShow=false;"
    >
        <financing-password-modal v-if="modalShow" :modalData="modalData" @ok="modalOk" @cancel="modalCancel"></financing-password-modal>
    </a-modal>

  </div>
</template>

<script>
import {mapGetters,mapMutations} from "vuex"
import { findExpenseTenantPage,findPayAlreadyList,findToPayList } from "@/api/pay.js"
import {getDic} from "@/api/dic.js"
import financingPasswordModal from "@/pages/review/financing/financing-password-modal"
export default {
    props:{
        tabType:{
            type: [String],
            required: false,
            default: function () {
                return ""; //所属tab的分类
            }
        },
        status:{
            type: [String],
            required: false,
            default: function () {
                return "";
            }
        },
    },
    name: "exdate-change-main",
    components:{
        financingPasswordModal
    },
    data() {
        return {
            searchData:{
                costTpCd:"",
                tranTime:[],
                tenantId:{},
            },
            formConfig:[
                {
                    prop: "costTpCd",
                    type: "select",
                    label: "费用类型",
                    option: [],
                    defaultProps: {
                        value: "dctVal",
                        label: "dctValNm"
                    }
                },
                {
                    prop: "tranTime",
                    type: "dateRange",
                    hide:this.tabType=="payfeeHas",
                    label: "生成时间",
                },
                {
                    prop: "tranTime",
                    type: "dateRange",
                    hide:this.tabType=="payfeeNo",
                    label: "付费时间",
                },
                {
                    prop: "tenantId",
                    type: "selectSearch",
                    label: "收费方",
                    option: [],
                    searchSource: true,
                    valuePorp: "tenantId",
                    labelPorp: "tenantName",
                    normal:true,
                    searchHandle: "handleSearchSff"
                },

            ],
            columns: [
                {
                    title:"费用流水号",
                    dataIndex: "feeSn",
                    width:"120px"
                },
                {
                    title:"费用类型	",
                    dataIndex: "costTpCd",
                    width:"120px",
                    scopedSlots: { customRender: "costTpCd" }
                },
                {
                    title:"收费方",
                    dataIndex: "tollerType",
                },
                {
                    title: "计费基数(元)",
                    dataIndex: "feeAcrdToAmt",
                    scopedSlots: { customRender: "feeAcrdToAmt" },
                },
                {
                    title: "费率",
                    dataIndex: "epsPct",
                    scopedSlots: { customRender: "epsPct" },
                },
                {
                    title: "协议付费",
                    dataIndex: "agrmPyFeePct",
                    scopedSlots: { customRender: "agrmPyFeePct" },
                },
                {
                    title: "待付金额(元)",
                    dataIndex: "pyFeeAmt",
                    hide:this.tabType=="payfeeHas",
                    scopedSlots: { customRender: "pyFeeAmt" },
                },
                {
                    title: "生成时间",
                    dataIndex: "feeDt",
                    hide:this.tabType=="payfeeHas",
                    scopedSlots: { customRender: "feeDt" },
                },
                {
                    title: "已付金额(元)",
                    dataIndex: "pyFeeAmt",
                    hide:this.tabType=="payfeeNo",
                    scopedSlots: { customRender: "pyFeeAmt" },
                },
                {
                    title: "付费时间",
                    dataIndex: "createTime",
                    hide:this.tabType=="payfeeNo",
                    scopedSlots: { customRender: "createTime" },
                },
                {
                    title: "相关编号",
                    dataIndex: "docId",
                    width:"120px",
                    scopedSlots: { customRender: "docId" },
                }
            ],
            tableData: [],
            pagination: {
                pageSize: 10,
                current: 1,
                sortField: "fncDt",
                sortOrder: "descend",
                total: 0,
            },
            loading: false,
            selectedRows: [],
            selectedRowKeys:[],
            checkLoad:false,
            checkLoadCancel:false,
            modalShow:false,
            modalData:{},
            modalTitle:"融资复核-同意",
            tableDataAllPage:[]

        };
    },
    computed: {
        ...mapGetters({
            userObj:"home/getUserObj"
        }),
        tableSelect(){
            return {
                selectedRowKeys: this.selectedRowKeys,
                selectedRows: this.selectedRows,
                onChange: this.onTableChange
            }
        },
    },
    methods: {
        pageInit(){
            getDic({dctTpCd:"EpsCollTpCd"})
            .then(res => {
                const index = this.formConfig.findIndex(item => item.prop == "costTpCd");
                this.formConfig[index].option = res.data||[];
            })
            .catch(err => {
                console.log(err);
            })
        },
        handleSearchSff(value,data,cfg){
            const cstIds = this.userObj.cstIds.join(",");
            let param = {
                queryType:0
            };
            this.getDataList(value,param,cfg);
        },
        getDataList(value,param={},cfg) { //下拉筛选
            const cstIds = this.userObj.cstIds.join(",");
            findExpenseTenantPage().then((res) => {
                const index = this.formConfig.findIndex(item => item.prop == cfg.prop);
                if(res.data && res.data.grid){
                    this.formConfig[index].option = res.data.grid.list||[];
                }else{
                    this.formConfig[index].option = []
                }
            })
            .catch((error)=>{
                 console.log(error);
            });
        },
        search(data) {
            this.searchData = data || this.searchData;
            this.getTableData();
        },
        getTableData(){
            if(this.tabType == "payfeeNo"){
                this.findToPayList();
            }
            if(this.tabType == "payfeeHas"){
                this.findPayAlreadyList();
            }
        },
        findToPayList(){
            this.loading = true;
            const params = {
                pageNum: this.pagination.current,
                pageSize: this.pagination.pageSize,
                costTpCd: this.searchData.costTpCd,
                stDt: this.searchData.tranTime[0],
                edDt: this.searchData.tranTime[1],
                tenantId: this.searchData.tenantId,
            };
            findToPayList(params)
            .then((res)=>{
                this.loading = false;
                this.pagination.total = res.data.grid.total;
                this.tableData = res.data.grid.list;
                this.renderTableAllPage();
            })
            .catch(err => {
                this.loading = false;
                console.log(err);
            })
        },
        findPayAlreadyList(){
            this.loading = true;
            const params = {
                pageNum: this.pagination.current,
                pageSize: this.pagination.pageSize,
                costTpCd: this.searchData.costTpCd,
                stDt: this.searchData.tranTime[0],
                edDt: this.searchData.tranTime[1],
                tenantId: this.searchData.tenantId.key,
            };
            findPayAlreadyList(params)
            .then((res)=>{
                this.loading = false;
                this.pagination.total = res.data.grid.total;
                this.tableData = res.data.grid.list;
                this.renderTableAllPage();
            })
            .catch(err => {
                this.loading = false;
                console.log(err);
            })
        },
        totalPayable(list=[],prop="pyFeeAmt") {
            return list.reduce((acc, rec) => {
                return acc + (+rec[prop] || 0);
            }, 0);
        },
        handleTableChange(pagination, filters, sorter) { //表格排序回调
            this.pagination = {
                current: pagination.current,
                pageSize: pagination.pageSize,
                sortField: sorter.field,
                sortOrder: sorter.order,
                total: this.pagination.total || 0,
            };
            this.getTableData();
        },
        onTableChange(selectedRows, data, data2) { //表格选择回调
            this.selectedRowKeys = selectedRows;
            this.selectedRows = this.tableDataAllPage.filter(item => selectedRows.indexOf(item.id+"_"+item.createTime)>-1);
        },
        renderTableAllPage(){ //记录加载的数据，用于记录选中的表格数据
            this.tableData.forEach(i => {
                let flag = this.tableDataAllPage.find(item => item.id == i.id && item.createTime == i.createTime);
                let idList = this.tableDataAllPage.map(i => i.id)
                if(!flag && idList.indexOf(i.id) == -1){
                    this.tableDataAllPage.push(i);
                }
            })
        },
        handleChangeTag(tag,checked){
            this.selectedTag = tag.value;
        },
        getCircleList(value){
            this.selectTenant(value);
        },
        selectTenant(value) { //下拉筛选
            selectTenant({
                pageSize: 10,
                tenantName: value || "",
                pageNum: 1,
            }).then((res) => {
                this.recPersonList = res.data.grid.list;
            })
            .catch((error)=>{
                console.log(error);
            });
        },
        toPageDetail(data){
            this.MENUAPI.goToOneTab({
                path: "circulation/borrow/details/"+ data.fncJrnlId,
            });
        },
        showModal(type){
            if(!this.selectedRows.length) {
                this.$message.warn("请至少选择一条数据");
                return;
            }
            this.modalData = {
                fncJrnlIds:this.selectedRows.map(i => i.fncJrnlId),
                selectedRows: this.utils.deepClone(this.selectedRows),
                status: type,
                sum:this.totalPayable(this.selectedRows),
            };
            this.modalTitle = ("融资复核-" + (type==2 ? "拒绝" : "同意"));
            this.modalShow = true;
        },
        modalOk(){
            this.modalShow = false;
            this.refresh();
        },
        modalCancel(){
            this.modalShow = false;
            this.refresh();
        },
        refresh(){
            this.tableDataAllPage = [];
            this.selectedRows = [];
            this.selectedRowKeys = [];
            this.getTableData();

        }
    },
    created() {
        this.formConfig = this.formConfig.filter(i => !i.hide);
        this.columns = this.columns.filter(i => !i.hide);
        this.getTableData();
        this.pageInit();
    },
    mounted() {},
    activated() {},
};
</script>
<style scoped>
    .input-content>div{
        margin:10px 20px 20px 0;
    }
    .common /deep/ .search-item-lable {
        min-width: 85px;
    }
</style>



// WEBPACK FOOTER //
// src/pages/account/payfee/payfee-main.vue